import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ChannelIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path d="M25 3C26.6569 3 28 4.34315 28 6V25C28 26.6569 26.6569 28 25 28H16C14.3431 28 13 26.6569 13 25V20C13 19.4477 13.4477 19 14 19C14.5523 19 15 19.4477 15 20V25C15 25.5523 15.4477 26 16 26H25C25.5523 26 26 25.5523 26 25V6C26 5.44772 25.5523 5 25 5H24C23.4477 5 23 4.55228 23 4C23 3.44772 23.4477 3 24 3H25ZM5 20C5.55228 20 6 20.4477 6 21V22C6 23.6569 7.34315 25 9 25C9.55228 25 10 25.4477 10 26C10 26.5523 9.55228 27 9 27C6.23858 27 4 24.7614 4 22V21C4 20.4477 4.44772 20 5 20ZM21 23C21.5523 23 22 23.4477 22 24C22 24.5523 21.5523 25 21 25H19C18.4477 25 18 24.5523 18 24C18 23.4477 18.4477 23 19 23H21ZM19 3C20.1046 3 21 3.89543 21 5V14C21 15.1046 20.1046 16 19 16H7.5L4.79102 17.9355L4.72754 17.9746C4.40434 18.142 4 17.9096 4 17.5283V5C4 3.89543 4.89543 3 6 3H19ZM6 14.6133L6.33789 14.3721L6.46777 14.2871C6.77852 14.0998 7.13524 14 7.5 14H19V5H6V14.6133Z" />
    </BaseIcon>
  );
};
